import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '@/components/feature/Sidebar';
import HeaderBar from '@/components/feature/HeaderBar';
import Footer from '@/components/feature/Footer';

export default function AppLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen w-full bg-background-50">
      <Sidebar mobileOpen={mobileOpen} onClose={() => setMobileOpen(false)} />

      <div className="flex min-w-0 flex-1 flex-col lg:ml-[264px]">
        <HeaderBar onMenu={() => setMobileOpen(true)} />

        <main className="flex-1">
          <div className="w-full px-4 py-6 md:px-8 md:py-8">
            <Outlet />
          </div>
        </main>

        <Footer />
      </div>
    </div>
  );
}